export function truncate(str, length=100) {
  return str?`${str.substring(0,length)}...`:str;
}

export function validateActionName(name) {
  const pattern = /^[a-zA-Z0-9_-]+$/;
  return pattern.test(name);
}

export function isValidURL(url) {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // Protocol (http or https)
    '((([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|' + // Domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP address (IPv4)
    '(\\:\\d+)?(\\/[-a-zA-Z\\d%_.~+]*)*' + // Port and path
    '(\\?[;&a-zA-Z\\d%_.~+=-]*)?' + // Query string
    '(\\#[-a-zA-Z\\d_]*)?$', // Fragment locator
    'i'
  );
  return urlPattern.test(url);
};

export function safeString(str) {
  return (typeof str === "string" ? str : '').trim();
}

// Placeholder tokens the backend puts in place of personal data, e.g. {{CREDIT_CARD_9116a512}}.
const PII_TOKEN = /\{\{[A-Za-z][A-Za-z0-9_]*_[0-9a-fA-F]{4,64}\}\}/g;
export const REDACTED = '[REDACTED]';

/**
 * Replaces PII placeholder tokens with "[REDACTED]" in every string of a response.
 * Returns the input untouched when it carries no token.
 */
export function redactPiiTokens(value) {
  if (typeof value === 'string') {
    return value.replace(PII_TOKEN, REDACTED);
  }
  if (Array.isArray(value)) {
    return value.map(redactPiiTokens);
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, redactPiiTokens(v)]));
  }
  return value;
}
